// 订单报备
import publicRequest from '@/plugin/axios/request-public.js';
// 订单报备-列表
export const workOrderList = (data) => publicRequest({
  url: '/vas/h5/workOrder/list',
  method: 'post',
  data
});
// 订单报备-新增
export const workOrderCreate = (data) => publicRequest({
  url: '/vas/h5/workOrder/create',
  method: 'post',
  data
});
// 订单报备-详情
export const workOrderDetail = (data) => publicRequest({
  url: '/vas/h5/workOrder/detail',
  method: 'post',
  data
});
// 订单报备-获取服务项目
export const getProductStandardSkus = (data) => publicRequest({
  url: '/vas/h5/productSku/standard/skus',
  method: 'post',
  data
});

